/*jslint white: true, browser: true, devel: true, nomen: true, sloppy: true, indent: 4, maxerr: 50,	 plusplus: true, vars: false */
/*jshint -W030, -W014, -W020, -W098 */
/*globals $, LZUTF8, DataBlocks, ReviewCanvas, demoData, FS, gtag */
var urlmap = {e: 'https://scannerlogs.ucscentral.com/lastscans/', c: 'https://scannerlogs-china.safesize.cn/lastscans'};
var skinmap = {s: 'safesize', e: 'eobuwie'};
var debug = {
    en: 0,
    log: function () {
        if (this.en && arguments.length) {
            console.log.apply(null, arguments);
        }
    }
};

var profileUrl = "https://scannerlogs.ucscentral.com/lastscans/90103789615524b2a2ee6fad3d63acd8739ee3b4aac3dd60f7503/"; // fallback for test and demo page
var translateUrl = "./demo";
var locale = null, localization = null, footData = { leftFoot: {}, rightFoot: {} };
var topCanvas = null, sideCanvas = null, threeCanvas = null;
var skin = "safesize.2x3.safesize";
var round_size = 0;
var content_only = false;
var body_height = 0;

var viewToggle = $(".cmn-toggle");
var getSubskin = function () {
    var skinParts = skin.split('.');
    return skinParts[skinParts.length - 1];
};

// google analytics preload-code
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'UA-135932376-1');

var threeSkins = {
    safesize: {
        dimensionColor: 0x4FABE0,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 255, g: 170, b: 0, a: 1.0},
        dimTextBackgroundColor: {r: 58, g: 70, b: 82, a: 0.85},
        dimTextColor: {r: 255, g: 255, b: 255, a: 1.0}
    },
    torfs: {
        dimensionColor: 0xFFCC00,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 228, g: 184, b: 6, a: 1.0},
        dimTextBackgroundColor: {r: 59, g: 63, b: 58, a: 0.9},
        dimTextColor: {r: 255, g: 204, b: 0, a: 1.0}
    },
    van_haren: {
        dimensionColor: 0xEB690A,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 211, g: 94, b: 9, a: 1.0},
        dimTextBackgroundColor: {r: 235, g: 105, b: 10, a: 0.9},
        dimTextColor: {r: 255, g: 255, b: 255, a: 1.0}
    },
    salomon: {
        dimensionColor: 0x000000,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 0, g: 0, b: 0, a: 1.0},
        dimTextBackgroundColor: {r: 0, g: 0, b: 0, a: 0.9},
        dimTextColor: {r: 255, g: 255, b: 255, a: 1.0}
    },
    eobuwie: {
        dimensionColor: 0x4CAF50,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 76, g: 175, b: 80, a: 1.0},
        dimTextBackgroundColor: {r: 255, g: 255, b: 255, a: 0.9},
        dimTextColor: {r: 76, g: 175, b: 80, a: 1.0}
    },
    esizeme: {
        dimensionColor: 0x2D9CDB,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 20, g: 116, b: 204, a: 1.0},
        dimTextBackgroundColor: {r: 45, g: 156, b: 219, a: 0.9},
        dimTextColor: {r: 255, g: 255, b: 255, a: 1.0}
    },
    ls: {
        leftFootColor: 0x5BA6D2,
        rightFootColor: 0x5BA6D2,
        leftWireframeColor: 0x6F9EBA,
        rightWireframeColor: 0x6F9EBA,
        wireframeOpacity: 0.1,
        growAnimTime: 1000
    },
    nb: {
        dimensionColor: 0xC05C55,
        dimTextFontsize: 72,
        dimTextBorderThickness: 6,
        dimTextBorderColor: {r: 225, g: 80, b: 80, a: 1.0},
        dimTextBackgroundColor: {r: 45, g: 20, b: 20, a: 0.85},
        dimTextColor: {r: 255, g: 255, b: 255, a: 1.0}
    },
    hoka: {
        archLabels: ['LOW_ARCH','MID_ARCH','HIGH_ARCH']
    },
    xebio_arch: {
        archLabels: ['LOW_ARCH','MID_ARCH','HIGH_ARCH']
    }
};
threeSkins.safesizev2 = threeSkins.safesize;
threeSkins.ccc = threeSkins.esizeme;
threeSkins.black = threeSkins.salomon;
threeSkins.zero = threeSkins.black;

function postMessage (message) {
    debug.log('postMessage:', message); // output to console if debugging
    if (window.self !== window.top) {
        window.parent.postMessage(message, '*'); // send event to parent if in iframe
    }
}

function isGoogleUp() {
        var gtm = document.createElement('script');
        gtm.async = 1;
        gtm.src = 'https://www.googletagmanager.com/gtag/js?id=UA-135932376-1';
        document.head.appendChild(gtm);
}

var tryLoadAnalytics = function() { // workaround to not load the GA if it's behind firewall.
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://www.googleapis.com/webfonts/v1/webfonts', true);
    xhr.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (!this.status) return; // if it's 0 it means it was a timeout.
        isGoogleUp();
    };
    xhr.timeout = 1000;
    xhr.send();
}();

function updateGtag(sc) {
    if (gtag instanceof Function) {
        gtag('set', {
            user_id: sc,
            agent: navigator.userAgent
        });
    }
}

function ReportEvent(category, action, label, interaction) {
    if (gtag instanceof Function) {
        gtag('event', action, {
            event_category: category,
            event_label: label,
            non_interaction: !interaction
        });
    }
}
//Load JS or CSS to document
function loadJsFile(filename) {
    var e = document.createElement('script');
    e.setAttribute("type", "text/javascript");
    e.setAttribute("src", filename);
    document.getElementsByTagName("head")[0].appendChild(e);
}

function makeResizeHandler(handle, delay) { // updates views on resize
    var height = 0,
        width = 0,
        timeout = null;
    delay = delay || 50;

    function watch(evt) {

        var _nbH = document.body.scrollHeight;
        if (body_height !== _nbH) {
            body_height = _nbH;
            postMessage({event: 'fp_resize', new_height: body_height});
        }
        var nheight = (evt.target || evt.currentTarget).innerHeight,
            nwidth = (evt.target || evt.currentTarget).innerWidth;

//                debug.log("resize: " + nwidth + " X " + nheight);

        if (nheight !== height || nwidth !== width) {
            height = nheight;
            width = nwidth;

            if (timeout)
                clearTimeout(timeout);

            setTimeout(function (height, width) {
                handle(height, width);
                timeout = null;
            }, delay);
        }
    }

    return watch;
}

function webglDetect(returnContext) { // detects if webgl is available
    if (!!window.WebGLRenderingContext) {
        var canvas = document.createElement('canvas'),
            names = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d'],
            context = false;

        for (var i = 0; i < 4; i++) {
            try {
                context = canvas.getContext(names[i]);
                if (context && typeof context.getParameter === 'function') {
                    // WebGL is enabled
                    if (returnContext) {
                        // return WebGL object if the function's argument is present
                        return {
                            name: names[i],
                            gl: context
                        };
                    }
                    // else, return just true
                    return true;
                }
            } catch (e) {
            }
        }
        // WebGL is supported, but disabled
        return false;
    }
    // WebGL not supported
    return false;
}

function hexToBase64(str) {
    return window.btoa(String.fromCharCode.apply(null,
        str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
    );
}

function base64ToHex(str) {
    for (var i = 0, bin = window.atob(str.replace(/[ \r\n]+$/, "")), hex = []; i < bin.length; ++i) {
        var tmp = bin.charCodeAt(i).toString(16);
        if (tmp.length === 1) tmp = "0" + tmp;
        hex[hex.length] = tmp;
    }
    return hex.join("");
}

function getDataFromURL (path, endpoint, callback) { // function for get request with callback
    path = path.replace(/^https?:/,''); // make all calls on the same protocol as page is loaded
    var url = path.charAt(path.length - 1) !== "/" ? path + "/" : path; //in case path is not ended with /
    url += endpoint;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status !== 200) {
            debug.log(this);
            callback(null);
            return;
        }
        callback(this.response);
    };
    xhr.send();
}

function setFootData(data, type) {  //set the foot data to more usable form
    switch (type) {
        case "lastscan":
            if(data && data.measurment && data.measurment.feetType === undefined) {
                if (data.manualArchType != null) { //for outdated scanners, arch_type
                    data.measurment.feetType = data.manualArchType;
                } else {
                    var lft, rft;
                    lft = data.measurment.leftFoot != null ? data.measurment.leftFoot.footType : null;
                    rft = data.measurment.rightFoot != null ? data.measurment.rightFoot.footType : null;
                    lft = lft == null ? rft : lft;
                    lft = rft != null && lft !== rft ? 2 : lft;
                    switch (lft) {
                        case 1:
                            data.measurment.feetType = "FLAT";
                            break;
                        case 2:
                            data.measurment.feetType = "NEUTRAL";
                            break;
                        case 3:
                            data.measurment.feetType = "HOLLOW";
                            break;
                    }
                }
            }
            footData.lastScan = data;
            break;
        case "data2D":
            if(data === null) {
                footData.lastScan.has2D = "none";
            } else {
                footData.lastScan.has2D = data.sideLeft === undefined && data.sideRight === undefined ? "top" : "both";
                footData.leftFoot.data2Dtop = data.bottomLeft;
                footData.rightFoot.data2Dtop = data.bottomRight;
                footData.leftFoot.data2Dside = data.sideLeft;
                footData.rightFoot.data2Dside = data.sideRight;
            }
            break;
        case "data3DLeft":
            footData.leftFoot.data3D = data;
            break;
        case "data3DRight":
            footData.rightFoot.data3D = data;
            break;
    }
    // is foot data complete?
    if (footData.lastScan !== undefined &&
        (footData.leftFoot.data2Dtop !== undefined || footData.lastScan.measurment.leftFoot === null || footData.lastScan.scanType === "3D") &&
        (footData.rightFoot.data2Dtop !== undefined  || footData.lastScan.measurment.rightFoot === null || footData.lastScan.scanType === "3D") &&
        (
            (footData.lastScan.scanType === "3D" &&
                (footData.leftFoot.data3D !== undefined || footData.lastScan.measurment.leftFoot === null) &&
                (footData.rightFoot.data3D !== undefined || footData.lastScan.measurment.rightFoot === null)) ||
            (footData.lastScan.scanType !== "3D")
        )) {
        update3DmodelDimensions(footData.lastScan.measurment, footData.leftFoot.data3D, footData.rightFoot.data3D);

        // init canvases.
        if(document.readyState === "complete" || document.readyState === "interactive") {
            init();
        } else {
            window.onload = init;
        }
    }
}

function update3DmodelDimensions(measurement, left, right) {
    var f = left,
        m = measurement.leftFoot;
    if (m && f) {
        if (!f.atyp && m.footType) f.atyp = m.footType;

        if (f.dh && f.dh.m && m.footHeight)
            f.dh.m = m.footHeightDim || Math.round(m.footHeight || 0);

        if (f.dl && f.dl.m && m.footLength)
            f.dl.m = m.footLengthDim || Math.round(m.footLength);

        if (f.dw && f.dw.m && m.footWidth)
            f.dw.m = m.footWidthDim || Math.round(m.footWidth);

        if (f.mtg && f.mtg.m && m.footGirth)
            f.mtg.m = m.footGirthDim || Math.round(m.footGirth);
    }
    f = right;
    m = measurement.rightFoot;
    if (m && f) {
        if (!f.atyp && m.footType) f.atyp = m.footType;

        if (f.dh && f.dh.m && m.footHeight)
            f.dh.m = m.footHeightDim || Math.round(m.footHeight || 0);

        if (f.dl && f.dl.m && m.footLength)
            f.dl.m = m.footLengthDim || Math.round(m.footLength);

        if (f.dw && f.dw.m && m.footWidth)
            f.dw.m = m.footWidthDim || Math.round(m.footWidth);

        if (f.mtg && f.mtg.m && m.footGirth)
            f.mtg.m = m.footGirthDim || Math.round(m.footGirth);
    }
}

function incorrectData () {
    var demo_preview = document.getElementById('demo_preview');
    if (demo_preview) demo_preview.classList.remove('preload');
}

function error (message) {
    var error = document.getElementById('error');
    if (error) {
        var trace = document.getElementById('trace');
        var parts = profileUrl.split('/');
        var id = parts.pop();
        if (!id) id = parts.pop(); // if no content, pull next one from behind (url ended with /)
        if (trace) trace.textContent = id.substring(0,13);
        error.classList.remove('preload');
    }
}

/* PARSE QUERY INTO CONFIGURATION */
var tmp = window.location.href.split("?");
if(tmp.length > 1) {
        var query_params = tmp[tmp.length-1].split('&');
        if(query_params.length) {
            var decoded = {};
            var decodedv2 = {};
            var extra_params = {};
            for(var i = 0; i < query_params.length; i++) {
                var param = decodeURIComponent(query_params[i].replace(/=+$/, ''));
                if (param.indexOf('=') < 0) {
                    try {
                        decoded = JSON.parse(LZUTF8.decompress(param, { inputEncoding: "Base64" }));
                        if (decoded.foot_scan_url !== undefined) profileUrl = decoded.foot_scan_url;
                        if (decoded.translations_url !== undefined) translateUrl = decoded.translations_url;
                        if (decoded.locale !== undefined) locale = decoded.locale;
                        if (decoded.skin !== undefined) skin = decoded.skin;
                        if (decoded.round_size === 1) round_size = decoded.round_size;
                    } catch (err) {
                        console.error(err);
                    }
                } else {
                    var key_val = param.split('=');
                    var key = key_val[0];
                    var val = key_val[key_val.length - 1];
                    if (key && val) {
                        if(key === 'v2') {
                            var p1 = val.split('_');
                            for(var j = 0; j < p1.length; j++) {
                                var p2 = p1[j].split('-');
                                decodedv2[p2[0]] = ['s', 'l'].indexOf(p2[0]) > -1 ? p2[1].replaceAll('+', '_') : p2[1];
                            }
                        } else {
                            extra_params[key] = val;
                        }
                    }
                }
            }
            debug.en = extra_params.debug === 'true';
            debug.log('decoded:', decoded);
            debug.log('decodedv2:', decodedv2);
            debug.log('extra params:', extra_params);
            if (Object.keys(decoded).length + Object.keys(decodedv2).length +Object.keys(extra_params).length < 1) {
                incorrectData();
            } else {
                var temp;
                if (decodedv2.f !== undefined) {

                    temp = decodedv2.f.split('.');
                    profileUrl = urlmap[temp[0]];
                    if (temp.length === 3 && (temp[1] === 'p')) {
                        profileUrl += temp[2];
                    } else {
                        var e = base64ToHex(temp[temp.length-1]);
                        var padded = temp[1] === 'bp' || (e.length % 2 === 0 && e.indexOf('0') === 0);
                        profileUrl += padded ? e.substr(1) : e;
                    }
                }
                if (decodedv2.t !== undefined) translateUrl = decodedv2.t;
                if (decodedv2.l !== undefined) locale = decodedv2.l;
                if (decodedv2.r === '1') round_size = 1;
                if (decodedv2.s !== undefined) {
                    temp = decodedv2.s.split('.');
                    if (skinmap[temp[0]]) temp[0] = skinmap[temp[0]];
                    if (temp.length === 2) temp.push(temp[0]);
                    skin = temp.join('.');
                }
                if (extra_params.foot_scan_url !== undefined) profileUrl = extra_params.foot_scan_url;
                if (extra_params.translations_url !== undefined) translateUrl = extra_params.translations_url;
                if (extra_params.locale !== undefined) locale = extra_params.locale;
                if (extra_params.skin !== undefined) skin = extra_params.skin;
                if (extra_params.round_size === '1') round_size = 1;
                if (extra_params.content === '1') content_only = true;
            }
            if(/^https?:\/\/scanner\.logs\.ucscentral\.com\.s3(-website-eu-west-1)?\.amazonaws\.com/.test(profileUrl)) {
                debug.log('Legacy url regex replacement.');
                profileUrl = profileUrl.replace(/^https?:\/\/scanner\.logs\.ucscentral\.com\.s3(-website-eu-west-1)?\.amazonaws\.com/, 'https://scannerlogs.ucscentral.com'); // workaround to pull all foot profiles from https
            }
            if (document.getElementsByTagName('base')) {
                var base = document.getElementsByTagName('base')[0].href;
                debug.log('Base href is:', base);
                if (base === 'https://safesizepublic-china.safesize.cn/foot_profile/v2/') {
                    profileUrl = profileUrl.replace('://s3.cn-northwest-1.amazonaws.com.cn/scanner.logs.ucscentral.com', '://scannerlogs-china.safesize.cn')
                        .replace('://scanner.logs.ucscentral.com.s3.amazonaws.com', '://scannerlogs-china.safesize.cn');
                    debug.log('Replaced profile url is:', profileUrl);
                }
            }

        }
} else incorrectData();

function updateDimension (dimension, value) { //update dimension visibility in all views
    if(topCanvas) topCanvas.updateConfig(dimension, value);
    if(sideCanvas) sideCanvas.updateConfig(dimension, value);
    if(threeCanvas) threeCanvas.updateConfig(dimension, value);
}

function switchTO2D(param3D) { //takes 3d property name and returns boolean if the 3d doesnt have model for that dimension but 2d does
    var param2D = param3D === "dh" ? "data2Dside" : "data2Dtop";
            return ((footData.leftFoot[param2D] || footData.rightFoot[param2D]) &&
                !((footData.leftFoot.data3D && footData.leftFoot.data3D[param3D]) ||
                    (footData.rightFoot.data3D && footData.rightFoot.data3D[param3D])));
}

function enableScroll() {
    if (subskin !== 'esizemev2') {
        return;
    }
    var pages = ["p1", "p2", "p3", "p4"];
    var touchstartX = 0;
    var touchcurrentX = 0;
    var touchendX = 0;
    var currentPage = 0;

    var rightcol = document.querySelector(".rightcol");
    var datablocks = document.querySelector(".datablocks_container");

    function handleDrag () { // this makes the dragging work
        datablocks.style.left = "" + ((-currentPage * window.innerWidth) + touchcurrentX - touchstartX) + "px";
    }

    function changePage (change) {
        rightcol.classList.remove.apply(rightcol.classList, pages);
        var page = currentPage + (change < 0 ? 1 : -1);
        currentPage = Math.min(pages.length - 1, Math.max(0,page));
        rightcol.classList.add(pages[currentPage]);
    }

    datablocks.addEventListener('touchstart', function (e) {
        if (window.innerWidth > 511) {
            return;
        }
        datablocks.classList.add('dragging'); // remove transition while drag is active
        touchstartX = e.changedTouches[0].screenX;
    });
    datablocks.addEventListener('touchmove', function (e) {
        if (window.innerWidth > 511) {
            return;
        }
        touchcurrentX = e.changedTouches[0].screenX;
        handleDrag();
    });
    datablocks.addEventListener('touchend', function (e) {
        if (window.innerWidth > 511) {
            return;
        }
        datablocks.classList.remove('dragging');
        touchendX = e.changedTouches[0].screenX;
        var dragSizeAndDirection = touchendX - touchstartX;
        if (dragSizeAndDirection && (Math.abs(dragSizeAndDirection) / window.innerWidth > 0.33)) { // if drag was strong enough page should be changed.
            changePage(dragSizeAndDirection);
        }
        datablocks.style.left = "";
    });
}

function eventHandler(eventCode, eventData) { //event handler for 3D and dataBlocks
    debug.log(eventCode, eventData); // debugging only
    if(eventData.view === "dataBlocks") {
        switch (eventCode) {
            case "INIT_COMPLETE":
                ReportEvent('datablocks', 'load', 'loaded', false);
                loadData(true);
                enableScroll();
                break;
            case "LENGTH_CB":
                ReportEvent('datablocks', eventData.value ? 'show' : 'hide', 'length', true);
                if(!eventData.init && viewToggle.is(":checked") && eventData.value  && switchTO2D("dl")) { //switch to 2D when height is selected and 3D model doesnt have length
                    viewToggle.prop("checked", false);
                    handleViewSwitching(viewToggle);
                }
                updateDimension("showLENGTH", eventData.value);
                break;
            case "WIDTH_CB":
                ReportEvent('datablocks', eventData.value ? 'show' : 'hide', 'width', true);
                if(!eventData.init && viewToggle.is(":checked") && eventData.value  && switchTO2D("dw")) { //switch to 2D when height is selected and 3D model doesnt have width
                    viewToggle.prop("checked", false);
                    handleViewSwitching(viewToggle);
                }
                updateDimension("showWIDTH", eventData.value);
                break;
            case "HEIGHT_CB":
                ReportEvent('datablocks', eventData.value ? 'show' : 'hide', 'height', true);
                if(!eventData.init && viewToggle.is(":checked") && eventData.value  && switchTO2D("dh")) { //switch to 2D when height is selected and 3D model doesnt have height
                    viewToggle.prop("checked", false);
                    handleViewSwitching(viewToggle);
                }
                updateDimension("showHEIGHT", eventData.value);
                break;
            case "GIRTH_CB":
                ReportEvent('datablocks', eventData.value ? 'show' : 'hide', 'girth', true);
                if(!eventData.init && !viewToggle.is(":checked") && eventData.value) { // switch to 3D when girth is selected, because there is no girth in 2D
                    viewToggle.prop("checked", true);
                    handleViewSwitching(viewToggle);
                }
                updateDimension("showGIRTH", eventData.value);
                break;
            case "ARCH_CB":
                ReportEvent('datablocks', eventData.value ? 'show' : 'hide', 'arch', true);
                if(!eventData.init && !viewToggle.is(":checked") && eventData.value) { // switch to 3D when arch type is selected, because there is no arch type in 2D
                    viewToggle.prop("checked", true);
                    handleViewSwitching(viewToggle);
                }
                updateDimension("showARCH", eventData.value);
                break;
            case "ARCH_TYPE_CHANGE":
                ReportEvent('datablocks', 'change arch_type', 'arch_type', false);
                break;
            case "INIT_FAIL":
                ReportEvent('datablocks', 'load', 'not_loaded', false);
                debug.log("DataBlocks initialization failed, message: " + eventData.message);
                loadData(false);
                break;
            case "LAYOUT":
                body_height = document.body.scrollHeight;
                postMessage({event: 'fp_resize', new_height: body_height});
                break;
            default:
                debug.log("Unknown event code: " + eventCode);
                break;
        }
    }
    else if(eventData.view === "libview3d") {
        switch (eventCode) {
            case "DIMENSIONS_ANIMATE_START":
                if(eventData.dimensions) {
                    for(var i in eventData.dimensions)
                            dataBlocks.select(i, eventData.dimensions[i], true); //init select dimensions
                }
                break;
            case "DIMENSIONS_ANIMATE_END":
                // handling code here.
                break;
            default:
                debug.log("Unknown event code: " + eventCode);
                break;
        }
    }
    else {
        debug.log('Unknown event. EventCode:', eventCode, ' EventData:', eventData);
    }
}

var dataBlocks = new DataBlocks();
var config = {
    debug: debug.en,
    locale: locale,
    // showChangeCircles: ['arch_type', 'size'],
    skin: skin,
    round_size: round_size
};

var header = document.getElementsByTagName('header')[0];
var footer = document.querySelector('div.footer');

var subskin = getSubskin();
if (['esizeme', 'esizemev2', 'ls', 'xebio', 'xebio_arch', 'apparel', 'ls_range', 'nb', 'black', 'salomon', 'marathon', 'zero'].indexOf(subskin) > -1) {
    var _skin = subskin;
    // skin overrides for style so we don't have to duplicate CSS
    if (_skin === 'ls_range') _skin = 'ls';
    if (_skin === 'zero') _skin = 'black';
    document.documentElement.classList.add(_skin);

    if (header) {
        if (['esizemev2', 'black'].indexOf(subskin) > -1) {
            header.querySelector('#logo img').src = 'img/logo.png';
        } else if (['salomon'].indexOf(subskin) > -1) {
            document.title = 'SALOMON';
            header.querySelector('#logo img').src = 'img/logo_salomon.png';
        } else if (['zero'].indexOf(subskin) > -1) {
            document.title = 'Z1R0';
            header.querySelector('#logo a').href = 'https://www.z1r0.com';
            header.querySelector('#logo img').src = 'img/logo_zero.png';
        } else if (subskin === 'ls' || subskin === 'ls_range') {
            header.querySelector('#logo img').src = 'img/logo_ls.svg';
        } else if (subskin === 'xebio' || subskin === 'xebio_arch') {
            header.querySelector('#logo img').src = 'img/logo_xebio.png';
        } else {
            header.querySelector('#logo img').src = 'img/logo_' + subskin + '.png';
            if (subskin === 'apparel') {
                header.style.backgroundImage = 'url(./img/header_apparel.png)';
                header.style.backgroundRepeat = 'round';
                header.style.backgroundSize = 'cover';
            }
            if (subskin === 'marathon') {
                header.querySelector('#second_logo').classList.remove('removed');
            }
        }
    }

    if (footer) {
        if (subskin === 'zero') {
            var _cp = footer.querySelector('.copyright');
            _cp.textContent = _cp.textContent.replace('SafeSize', 'Z1R0');
        } else if (subskin === 'esizeme') {
            var culink = footer.querySelector('a');
            culink.href = 'mailto:info@esize.me';
            culink.style.display = 'unset';
        }
    }
}

if (content_only) {
    document.body.classList.add('content_only');
}

header.classList.remove('preload');

dataBlocks.init("rightcol", config, eventHandler);

var grid = document.querySelector(".grid");
if (config.skin.indexOf('eobuwie') === 0) {
    if(grid != null) {
        grid.classList.add('eobuwie');
    }
}

function loadData(blocksLoaded) { // loads all relevant data (translations -> lastscan -> 2D -> 3D)
    getDataFromURL(translateUrl, "foot.json?ver=project_version", function (response) {
        localization = JSON.parse(response);
        var locales = { default: "EN" };
        var keys = Object.keys(localization);
        if (keys.length && localization.hasOwnProperty(keys[0])) {
            for (var lang in localization[keys[0]]) {
                if (!locales.best) locales.best = lang; //first language from the translation JSON
                if (lang === locales.default) locales.best = lang; //override with default (EN) language if found
                if (lang === locale) { //override with input locale if found and exit search
                    locales.best = lang;
                    break;
                }
            }
        }
        locale = locales.best;
        debug.log("Displaying foot profile using locale: ", locale);
        if(blocksLoaded) dataBlocks.setLocalization(this.localization, locale);
        getDataFromURL(profileUrl, "lastscan.json", function (response) { //todo catch no network / no file
            if (response === null) {
                error();
            } else {
                setFootData(JSON.parse(response), "lastscan");
                updateGtag(footData.lastScan.person.safeSize.toString());
                ReportEvent('data', 'recieve', 'lastscan', false);
                if (blocksLoaded) dataBlocks.setData(footData.lastScan);
                getDataFromURL(profileUrl, "contours.json", function (response) {
                    ReportEvent('data', 'recieve', 'contours', false);
                    setFootData(JSON.parse(response), "data2D");
                    if (footData.lastScan.scanType === "3D") {
                        if (footData.lastScan.measurment.leftFoot != null) {
                            getDataFromURL(profileUrl, "foot_left.json", function (response) {
                                ReportEvent('data', 'recieve', 'foot_left', false);
                                setFootData(JSON.parse(response), "data3DLeft");
                            });
                        } else setFootData(null, "data3DLeft");
                        if (footData.lastScan.measurment.rightFoot != null) {
                            getDataFromURL(profileUrl, "foot_right.json", function (response) {
                                ReportEvent('data', 'recieve', 'foot_right', false);
                                setFootData(JSON.parse(response), "data3DRight");
                            });
                        } else setFootData(null, "data3DRight");
                    }
                });
            }
        });
    });
}

function getDemoData(data, measurment, footText, view) { //only when the scan is 3D with missing 2D contours and browser doesnt support webGL

    //debug.log(data);

    var contourData = {},
        contour;
    // init data


    contourData.globalAlpha = 1; // 0.90;

    contourData.contour = contour = contourData.contour || {
        data: []
    };
    contour.data.length = 0;

    contourData.topBBox = contourData.topBBox || [];
    contourData.topBBox.length = 0;

    //fill BBox data
    if (data.topBBox && data.topBBox.length) {
        for (var i = 0, n = data.topBBox.length; i < n; i++) {
            contourData.topBBox[i] = data.topBBox[i];
        }
    }

    /*utl.*/
    //cloneArray(data.scannedTopContours[0],);
    if (view === "topView") {
        contour.data = data.scannedTopContours[0];
    } else {
        contour.data = data.footContourSide;
    }
    contourData.mm = null;
    contourData.footLength = measurment!== null ? measurment.footLengthDim || Math.round(measurment.footLength*10) : 0;
    contourData.footWidth = measurment!== null ? measurment.footWidthDim || Math.round(measurment.footWidth*10) : 0;
    contourData.footHeight = measurment!== null ? measurment.footHeightDim || Math.round(measurment.footHeight*10) : 0;
    contourData.bottomText = footText;
    contourData.shoeNumber = null;
    contourData.scaled = false;

    return contourData;
}

function get2DData(data, measurment, footText, view) { // retrieve 2D data

    var contourData = {},
        contour;

    contourData.globalAlpha = 1;

    contourData.contour = contour = contourData.contour || {
        data: []
    };
    contour.data.length = 0;

    /*utl.*/
    //cloneArray(data.scannedTopContours[0],);
    if (view === "topView") {
        contour.data = data.data2Dtop;
    } else {
        contour.data = data.data2Dside;
    }
    contourData.mm = null;
    contourData.footLength = measurment != null ? measurment.footLengthDim || Math.round(measurment.footLength*10) : 0;
    contourData.footWidth = measurment != null ? measurment.footWidthDim || Math.round(measurment.footWidth*10) : 0;
    contourData.footHeight = measurment != null ?measurment.footHeightDim || Math.round(measurment.footHeight*10) : 0;
    contourData.bottomText = footText;
    contourData.shoeNumber = null;
    contourData.scaled = false;

    return contourData;
}

function hide3Dcanvas() { // hides 3d canvas
    $("#canvasTopWrapper").css("visibility", "visible");
    $("#canvasSideWrapper").css("visibility", "visible");
    $("#canvas3d").hide();
    $("#mainView").addClass("min500");
}

function init2DCanvas(type) { // initializes 2D canvases

    var l = localization.LENGTH[locale].long.charAt(0).toLowerCase(),
        w = localization.WIDTH[locale].long.charAt(0).toLowerCase(),
        h = localization.HEIGHT[locale].long.charAt(0).toLowerCase();

    var canvasTopWrapper = document.getElementById("canvasTopWrapper");
    var canvas2dtop = document.getElementById("canvas2dtop");

    topCanvas = new ReviewCanvas();

    var topCanvasConfig = {
        view: "topView",
        letterLength: l,
        letterWidth: w,
        letterHeight: h
    };

    topCanvas.init(canvas2dtop, canvasTopWrapper, topCanvasConfig);
    if(type === "DEMO") {
        topCanvas.leftFoot = getDemoData(demoData.leftFoot, footData.lastScan.measurment.leftFoot, localization.LEFT[locale].long.toLowerCase() + " (mm)", topCanvasConfig.view);
        topCanvas.rightFoot = getDemoData(demoData.rightFoot, footData.lastScan.measurment.rightFoot, localization.RIGHT[locale].long.toLowerCase() + " (mm)", topCanvasConfig.view);
    } else {
        topCanvas.leftFoot = get2DData(footData.leftFoot, footData.lastScan.measurment.leftFoot, localization.LEFT[locale].long.toLowerCase() + " (mm)", topCanvasConfig.view);
        topCanvas.rightFoot = get2DData(footData.rightFoot, footData.lastScan.measurment.rightFoot, localization.RIGHT[locale].long.toLowerCase() + " (mm)", topCanvasConfig.view);
    }


    if(footData.lastScan.has2D !== "top") {
        var canvasSideWrapper = document.getElementById("canvasSideWrapper");
        var canvas2dside = document.getElementById("canvas2dside");

        sideCanvas = new ReviewCanvas();

        var sideCanvasConfig = {
            view: "sideView",
            letterLength: l,
            letterWidth: w,
            letterHeight: h,
            showFootText: false
        };

        sideCanvas.init(canvas2dside, canvasSideWrapper, sideCanvasConfig);
        if(type === "DEMO") {
            sideCanvas.leftFoot = getDemoData(demoData.leftFoot, footData.lastScan.measurment.leftFoot, localization.LEFT[locale].long.toLowerCase() + " (mm)", sideCanvasConfig.view);
            sideCanvas.rightFoot = getDemoData(demoData.rightFoot, footData.lastScan.measurment.rightFoot, localization.RIGHT[locale].long.toLowerCase() + " (mm)", sideCanvasConfig.view);
        } else {
            sideCanvas.leftFoot = get2DData(footData.leftFoot, footData.lastScan.measurment.leftFoot, localization.LEFT[locale].long.toLowerCase() + " (mm)", sideCanvasConfig.view);
            sideCanvas.rightFoot = get2DData(footData.rightFoot, footData.lastScan.measurment.rightFoot, localization.RIGHT[locale].long.toLowerCase() + " (mm)", sideCanvasConfig.view);
        }
    }

    setTimeout(function () {
        topCanvas.draw(true);
        if(sideCanvas) sideCanvas.draw(true);
    }, 100);
}

function getTextForCurrentLocale(key, long) {
    return localization[key][locale][long ? 'long' : 'short'];
}

function initThreeCanvas() { // initializes 3D canvas

    var canvasWrapper = document.getElementById("canvas3d");
    var config = {
        animateCameraTarget: true,
        background: 0xFFFFFF,
        leftFootColor: 0xBBBBBB,
        rightFootColor: 0xBBBBBB,
        dimensionColor: 0x4FABE0,
        leftWireframeColor: 0xBBBBBB,
        rightWireframeColor: 0xBBBBBB,
        wireframeOpacity: 0.12,
        showFootModel: "both",
        displayGrid: false,
        gridColor: 0xDDDDDD,
        growAnimTime: 1500,
        zoomFactor: 1.2,
        doubleSideTriangles: 10000,
        showLENGTH: true,
        standingPlatePlane: false,
        standingPlateTexture: false,
        dimConvertFunction: function (x) {return x;}
    };

    var subSkin = getSubskin();
    if(subSkin !== 'safesize' && threeSkins[subSkin]) {
        for(var prop in threeSkins[subSkin]) {
            if(threeSkins[subSkin].hasOwnProperty(prop)) {
                if (prop === 'archLabels') {
                    if (threeSkins[subSkin][prop].length > 0) {
                        config[prop] = threeSkins[subSkin][prop].map(getTextForCurrentLocale);
                    }
                } else {
                    config[prop] = threeSkins[subSkin][prop];
                }
            }
        }
    }

    threeCanvas = new FS.ThreeCanvas();
    debug.log('Config for libview3D:', config);
    threeCanvas.init(canvasWrapper, config, eventHandler);
}

// function displayData() {
//
//     //prikaže model brez animacije
//     var displayModel = true;
//     threeCanvas.setModels(footData.leftFoot.data3D, footData.rightFoot.data3D, displayModel);
// }

function displayDataAnimate() {

    //prikaze model z animacijo
    var displayModel = false;
    threeCanvas.setModels(footData.leftFoot.data3D, footData.rightFoot.data3D, displayModel); // this code will change in near future when the data is provided with JSON.

    threeCanvas.animate(true);
    // kadar 3d view ni prikazan naj se pokliče
    //  threeCanvas.enableLoop(false);   da ni renderiranje 3D modela, ki ni viden

    //ko je spet viden naj se nastavi:
    threeCanvas.enableLoop(true);
}

// function threeCanvasClear() {
//     var left = true, right = true, grid = true;
//     threeCanvas.clear(left, right, grid);
// }
//
// function threeCanvasDispose() {
//     // when removing view
//     threeCanvas.dispose();
// }

/* ------------------------------------------------- */
function convertDimensionsWithDecimal(foot, converter) {
    var dimensions = ["footLength", "footWidth", "footHeight", "footGirth"];
    var _set = 0;
    for (var _i in dimensions) {
        var _d = dimensions[_i];
        if (foot[_d]) {
            foot[_d+'Dim'] = converter(foot[_d]);
            _set = 1;
        }
    }
    return _set;
}

function convertMeasurementsWithDecimal(measurment, dimUnit) {
    var converter = new FS.genMMConverter(dimUnit);
    if (convertDimensionsWithDecimal(measurment.leftFoot, converter)) measurment.leftFoot.dimUnit = dimUnit;
    if (convertDimensionsWithDecimal(measurment.rightFoot, converter)) measurment.rightFoot.dimUnit = dimUnit;
}

function onLoad() {
    ReportEvent('config', '3d', 'version: ' + FS.version(), false);
    debug.log('loaded library:' + FS.version());

    if (footData.lastScan && footData.lastScan.dimensionUnit) {
        convertMeasurementsWithDecimal(footData.lastScan.measurment, footData.lastScan.dimensionUnit);
        update3DmodelDimensions(footData.lastScan.measurment, footData.leftFoot.data3D, footData.rightFoot.data3D);
        dataBlocks.setData(footData.lastScan);
    }

    initThreeCanvas();
    displayDataAnimate();
    $("#viewSwitch").show();
    $("#loading").hide();
}

function redrawComponents() { // redraws all components
    if (topCanvas) topCanvas.draw(true);
    if (sideCanvas) sideCanvas.draw(true);
    if (threeCanvas) threeCanvas.redraw();
    if (dataBlocks) dataBlocks.redraw();
}

window.addEventListener('resize', makeResizeHandler(redrawComponents));

function getAvailableDimensions () { // create and return a list of dimensions that are selectable
    var dim = [], left = footData.leftFoot.data3D, right = footData.rightFoot.data3D;
    if(left || right) {
        if((left && left.dl) || (right && right.dl)) dim.push("length");
        if((left && left.dw) || (right && right.dw)) dim.push("width");
        if((left && left.dh) || (right && right.dh)) dim.push("height");
        if((left && left.mtg) || (right && right.mtg)) dim.push("girth");
        if((left && left.da) || (right && right.da)) dim.push("arch_type");
    }
    if(footData.leftFoot.data2Dtop || footData.rightFoot.data2Dtop) {
        if(dim.indexOf("length") < 0) dim.push("length");
        if(dim.indexOf("width") < 0) dim.push("width");
    }
    if(footData.leftFoot.data2Dside || footData.rightFoot.data2Dside)
        if(dim.indexOf("height") < 0) dim.push("height");
    return dim;
}

function init() { // init all components
    body_height = document.body.scrollHeight;
    postMessage({event: 'fp_resize', new_height: body_height});
    dataBlocks.setSelectableDimensions(getAvailableDimensions());
    if (footData.lastScan.scanType === "3D") {
        if (webglDetect()) {
            //set library onLoad callback
            window._FS = {onLoad: onLoad};
            //load library
            loadJsFile("js/libview3d.js?ver=project_version");
            $("#canvas3d").css("height", "calc(100% - 34px)");
            if (footData.lastScan.has2D === "top") {
                $("#canvas2dside").hide();
                $("#canvasTopWrapper").css("height", "calc(100% - 34px)");
            } else {
                $("#canvasTopWrapper").css("height", "calc(70% - 17px)");
            }
        } else { //no webgl, show only 2d
            ReportEvent('config', 'webgl', 'not_available', false);
            debug.log("No WebGL detected, loading 2D View only.");
            hide3Dcanvas();
            if (footData.lastScan.has2D === "top") {
                $("#canvas2dside").hide();
                $("#canvasTopWrapper").css("height", "100%");
            } else {

                $("#canvasTopWrapper").css("height", "70%");
            }
        }
        if (footData.lastScan.has2D === "none") {  //no 2d scan
            ReportEvent('config', '2d', 'show_demo', false);
            debug.log("No 2D scan present, showing demo contours.");
            init2DCanvas("DEMO");
        } else init2DCanvas();  //both contours
    } else {
        ReportEvent('config', '3d', 'not_available', false);
        debug.log("Scan is 2D, loading 2D View only.");
        hide3Dcanvas();
        $("#block_height").css("visibility", "hidden");
        $("#block_girth").css("visibility", "hidden");
        if (footData.lastScan.has2D === "top") {
            $("#canvas2dside").hide();
            $("#canvasTopWrapper").css("height", "calc(100%)");
            init2DCanvas();
        } else init2DCanvas();
    }
}

function handleViewSwitching(toggle) { //handles switching between 2D and 3D
    if (toggle.is(":checked")) {
        $("#mainView").removeClass("min500");
        $("#canvas3d").css("z-index", 60);
        threeCanvas.enableLoop(true);
    } else {
        $("#mainView").addClass("min500");
        $("#canvasTopWrapper").css("visibility", "visible");
        $("#canvasSideWrapper").css("visibility", "visible");
        $("#canvas3d").css("z-index", 40);
        threeCanvas.enableLoop(false);
    }
    redrawComponents();
    body_height = document.body.scrollHeight;
    postMessage({event: 'fp_resize', new_height: body_height});
}

viewToggle.on('change', function () {
    ReportEvent('config', 'change_view', $(this).is(':checked') ? '3d' : '2d', true);
    handleViewSwitching($(this));
});

$(function() { //handles "sticky-hovering" on mobile devices
    if ("ontouchstart" in window || "ontouch" in window) { $('body').addClass('touch'); }
});
